import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
} from "react-router-dom";
import { YMInitializer } from 'react-yandex-metrika';
import DomainRoutes from "./navigation/DomainRoutes";
import './index.css';

ReactDOM.render(
  <Router>
    <React.StrictMode>
      <YMInitializer accounts={[70864666, 86989752]} options={{webvisor: true, trackHash: true}} version="2" />
      <DomainRoutes className="App" />
    </React.StrictMode>
  </Router>,
  document.getElementById('root')
);
